// src/pages/doctorPages/Settings/settingsTourConfig.js

export const settingsTourSteps = [
    {
        popover: {
            title: "Bienvenue dans les Paramètres ⚙️",
            description: "Gérez votre profil, vos informations personnelles et vos préférences de notifications.",
            side: "over",
        },
    },
    {
        element: ".settings-profile-header",
        popover: {
            title: "Photo de Profil 👤",
            description: "Cliquez sur le bouton pour modifier votre photo de profil. Formats acceptés : JPG, PNG (max 3MB).",
            position: "bottom",
        },
    },
    {
        element: ".settings-card:first-of-type",
        popover: {
            title: "Informations Personnelles 📝",
            description: "Mettez à jour vos informations : nom complet, email, date de naissance et numéro de téléphone.",
            position: "top",
        },
    },
    {
        element: ".settings-form-grid",
        popover: {
            title: "Formulaire de Profil 📋",
            description: "Modifiez vos coordonnées professionnelles qui apparaîtront sur vos ordonnances et votre profil.",
            position: "right",
        },
    },
    {
        element: ".settings-card:last-of-type",
        popover: {
            title: "Préférences de Notifications 🔔",
            description: "Activez ou désactivez les notifications selon vos préférences : rendez-vous, messages, mises à jour, etc.",
            position: "top",
        },
    },
    {
        element: ".settings-notification-list",
        popover: {
            title: "Types de Notifications 📬",
            description: "Contrôlez chaque type de notification avec les boutons toggle pour personnaliser votre expérience.",
            position: "right",
        },
    },
    {
        element: ".settings-footer-fixed",
        popover: {
            title: "Sauvegarder les Modifications 💾",
            description: "N'oubliez pas de cliquer sur ce bouton pour enregistrer toutes vos modifications.",
            position: "top",
        },
    },
    {
        popover: {
            title: "Configuration Terminée ! ✅",
            description: "Vos paramètres sont maintenant personnalisés. Vous pouvez revenir ici à tout moment pour les modifier.",
            side: "over",
        },
    },
];